/* eslint-disable no-underscore-dangle */
import {
  CreateSignoutRequestArgs,
  IWindow,
  NavigateResponse,
  SignoutResponse,
  UserManager,
} from 'oidc-client-ts';

export class PostSignoutUserManager extends UserManager {
  protected override async _signoutStart(
    args: CreateSignoutRequestArgs | undefined,
    handle: IWindow,
  ): Promise<NavigateResponse> {
    const logger = this._logger.create('_signoutStart');
    try {
      const user = await this._loadUser();
      logger.debug('loaded current user from storage');

      if (this.settings.revokeTokensOnSignout) {
        await this._revokeInternal(user);
      }

      const idToken = user && user.id_token;
      if (idToken) {
        logger.debug('setting id_token_hint in signout request');
      }

      const signoutRequest = await this._client.createSignoutRequest(args);
      logger.debug('got signout request');

      return await handle.navigate({
        url: signoutRequest.url,
        state: signoutRequest.state?.id,
        scriptOrigin: this.settings.iframeScriptOrigin,
      });
    } catch (err) {
      logger.debug('error after preparing navigator, closing navigator window');
      handle.close();
      throw err;
    }
  }

  protected override async _signoutEnd(url: string): Promise<SignoutResponse> {
    const logger = this._logger.create('_signoutEnd');

    await this.clearStaleState();
    await this.removeUser();

    const signoutResponse = await this._client.processSignoutResponse(url);
    logger.debug('got signout response');

    return signoutResponse;
  }
}

export default PostSignoutUserManager;
